import { useStore } from '@nanostores/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
  MenuDropdownCheckboxItem,
  MenuDropdownSubContent,
  MenuDropdownSubTrigger,
  MenuDropdownItemIndicator,
} from './BaseMenuDropdown';
import { setTheme, themeOptionStore } from '~/lib/stores/theme';
import { themeLabels, type ThemeOption } from '~/types/theme';

const themeIconMap: Record<ThemeOption, string> = {
  system: 'i-lucide:monitor',
  light: 'i-lucide:sun',
  dark: 'i-lucide:moon',
};

export interface ThemeDropdownItemProps {
  isLoading: boolean;
}

export function ThemeDropdownItem({ isLoading }: ThemeDropdownItemProps) {
  const theme = useStore(themeOptionStore);

  return (
    <DropdownMenu.Sub>
      <MenuDropdownSubTrigger disabled={isLoading}>
        <span className="i-lucide:moon size-4 mt-0.5 group-hover:text-bolt-elements-textPrimary" />
        Theme
        <span className="i-lucide:chevron-right size-4 mt-0.5 group-hover:text-bolt-elements-textPrimary ml-auto opacity-40" />
      </MenuDropdownSubTrigger>
      <DropdownMenu.Portal>
        <MenuDropdownSubContent className="p-1">
          {Object.entries(themeLabels).map(([key, label]) => (
            <MenuDropdownCheckboxItem checked={theme === key} key={key} onSelect={() => setTheme(key as ThemeOption)}>
              <span
                className={themeIconMap[key as ThemeOption] + ' size-4 group-hover:text-bolt-elements-textPrimary'}
              />
              {label}
              <MenuDropdownItemIndicator>
                <span className="i-lucide:check size-4 group-hover:text-bolt-elements-textPrimary" />
              </MenuDropdownItemIndicator>
            </MenuDropdownCheckboxItem>
          ))}
        </MenuDropdownSubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
}
